<?php

Namespace View ;

class UserAccountView extends \Core\View {

    public function display($data) {
        $tplfunc = \Core\View::$template ;
        $tpl_data = \Core\View::parse_view_template($tplfunc) ;
        \Core\View::execute_view_template('#template', $tpl_data) ;
    }

    public function displayAccount($binder) {
        \ISOPHP\js_core::$console->log('display interviews') ;
        $jQuery =  \ISOPHP\js_core::$jQuery ;
        $tplfunc = \Core\View::$template ;
        \ISOPHP\js_core::$console->log('pl func', $tplfunc) ;
        $tpl_data = $tplfunc() ;
        $jQuery('#user_account')->html($tpl_data) ;
        \ISOPHP\js_core::$console->log('Retrieved interviews displayed.') ;
        $binder();
    }

    // public function displayCards($binder, $type) {
    //     \ISOPHP\js_core::$console->log('display '.$type.' cards') ;
    //     $jQuery =  \ISOPHP\js_core::$jQuery ;
    //     $tplfunc = \Core\View::$template ;
    //     \ISOPHP\js_core::$console->log('pl func', $tplfunc) ;
    //     $tpl_data = $tplfunc() ;
    //     $jQuery('#'.$type.'_cards_wrap')->html($tpl_data) ;
    //     \ISOPHP\js_core::$console->log('binding cards to #'.$type.'_cards_wrap') ;
    //     $binder();
    // }

}


// WEBPACK FOOTER //
// app/UserAccount/View/UserAccountView.php